import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevateYourDigitalPresence from "./sections/ElevateYourDigitalPresence";
import Services from "./sections/Services";
import OurCoreExpertise from "./sections/OurCoreExpertise";
import MasteringGoogleListings from "./sections/MasteringGoogleListings";
import CommonQuestions from "./sections/CommonQuestions";
import ChallengesWeOvercome from "./sections/ChallengesWeOvercome";
import DominateYourLocalMarket from "./sections/DominateYourLocalMarket";
import ReadyToBuildYourFuture from "./sections/ReadyToBuildYourFuture";
import StartYourJourney from "./sections/StartYourJourney";
import Pricing from "@/pages/Seo/sections/Pricing";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevateYourDigitalPresence />
      <Services />
      <OurCoreExpertise />
      <MasteringGoogleListings />
      <ChallengesWeOvercome />
      <CommonQuestions />
      <DominateYourLocalMarket />
      <ReadyToBuildYourFuture />
      <StartYourJourney />
      <Footer />
    
      <Pricing /></div>;
}